module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/broom-754e03052876ca841bc8e1c158b5b129.svg";